import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHeartSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      d="m11.29 6.835.71.715.71-.715.691-.696a3.847 3.847 0 0 1 5.465 0 3.933 3.933 0 0 1 0 5.526l-.691.696L12 18.58l-6.175-6.22-.691-.697a3.933 3.933 0 0 1 0-5.525 3.847 3.847 0 0 1 5.465 0l.691.696Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconHeartSharpLine);
export default Memo;
